<template>
  <div>
    <div class="container-fluid">
      <div class="row p-3" style="background:darkblue">
        <div class="col-9">
          <h2>Piaraam</h2>
        </div>
        <div class="col-3 justify-content-between">
          <router-link :to="{ name: 'SignUp' }" class="m-2">SignUp</router-link>
          <router-link :to="{ name: 'Login' }" class="m-2">Login</router-link>
        </div>
      </div>
    </div>
    <div class="container">
      <h3 class="my-5 text-primary">SignUp</h3>
      <div class="row">
        <form @submit.prevent="signUp()">
          <div class="form-group">
            <label for="exampleInputPassword1">Email</label>
            <input
              type="email"
              class="form-control"
              placeholder="Email"
              v-model="email"
            />
          </div>
          <div class="form-group">
            <label for="exampleInputPassword1">Password</label>
            <input
              type="password"
              class="form-control"
              placeholder="Password"
              v-model="password"
            />
          </div>
          <button type="submit" class="btn btn-primary">Submit</button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
export default {
  name: "SignUp",
  data() {
    return {
      email: "",
      password: "",
    };
  },
  methods: {
    signUp() {
      if (this.email != "" && this.password != "") {
        console.log({ email: this.email, password: this.password });

        firebase
          .auth()
          .createUserWithEmailAndPassword(this.email, this.password)
          .then((res) => {
            console.log(res);
            if (res.additionalUserInfo.isNewUser == true) {
              alert("User Is Been Succefully Added");
            }
          })
          .catch((err) => alert(err.message));
      } else {
        alert("Please Enter Email And Password");
      }
    },
  },
};
</script>
